import "./Skillcard.css";
import useInView from "../../hooks/useInView";

function Skillcard(props) {
  const [ref, isVisible] = useInView(0.2);

  return (
    <div
      ref={ref}
      className={`skillcard reveal-animation ${isVisible ? "visible" : ""}`}
    >
      <div className="row">
        <div className="col-12">
          <div className="skillcard-header-container">
            <h6 className="skillcard-title text-center">
              {props.data.skilltitle}
            </h6>
          </div>
        </div>
      </div>

      {/* Desktop: original icon grid */}
      <div className="row justify-content-center skills-desktop">
        {props.data.skills.map((skill, index) => (
          <div
            className="skillcard-item col-sm-6 col-md-3 col-lg-2 text-center"
            key={index}
          >
            <img className="logo-card" src={skill.logo} alt={skill.caption} loading="lazy" />
            <p className="logo-card-caption-desktop">{skill.caption}</p>
          </div>
        ))}
      </div>

      {/* Mobile: flowing pill layout */}
      <div className="skills-flow skills-mobile">
        {props.data.skills.map((skill, index) => (
          <div className="skill-pill" key={index}>
            <img className="skill-pill-icon" src={skill.logo} alt={skill.caption} loading="lazy" />
            <span className="skill-pill-label">{skill.caption}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skillcard;
